import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=915d266c&"
import script from "./Rooms.vue?vue&type=script&lang=js&"
export * from "./Rooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports